<app-dialog
  [title]="'delistSetting.title' | translate"
  [confirmation]="'delistSetting.button' | translate"
  (save)="onSubmit()"
>
  <div id="delist-dialog">
    <div mat-dialog-content id="delist-dialog">
      <p>{{ 'delistSetting.description' | translate }}</p>
    </div>
    <ng-container *ngIf="!isLoadingData; else loader">
      <form [formGroup]="formGroup">
        <mat-label class="d-flex">
          <label>{{ 'delistSetting.label' | translate }}</label>
        </mat-label>
        <mat-form-field appearance="outline" color="accent">
          <mat-select apperance="outline" formControlName="delist" placeholder="{{ 'delistSetting.delistOptions.none' | translate }}" track="Inventory, delist_dialog_select_type">
            <mat-option value="">{{ 'delistSetting.delistOptions.none' | translate }}</mat-option>
            <mat-option value="all">{{ 'delistSetting.delistOptions.all' | translate }}</mat-option>
            <mat-option value="new">{{ 'delistSetting.delistOptions.new' | translate }}</mat-option>
            <mat-option value="used">{{ 'delistSetting.delistOptions.used' | translate }}</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </ng-container>

    <ng-template #loader>
      <ngx-skeleton-loader [theme]="{ width: '100%', height: '50px' }"></ngx-skeleton-loader>
    </ng-template>
  </div>
</app-dialog>

